const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/sections/ZuweisenderArzt.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ArztBlock, ArztFieldsConfig } from 'App/components/eCheckin/components/fields/ArztBlock';
import { createFieldPath, fieldValueIsNot } from 'App/components/eCheckin/utils';
import { ZuweisenderArztField } from './components/metakat/ZuweisenderArzt/ZuweisenderArztField';
import { AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';

const arztFieldsConfig: ArztFieldsConfig = {
    tel: {
        included: false,
    },
};
const addressFieldsConfig: AddressFieldsConfig = {
    country: {
        included: false,
    },
};

export const ZuweisenderArzt = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const { formatMessage } = useIntl();

    const PATH_REFFERED_DOCTOR = createFieldPath(path, 'refferedDoctor');

    const eCheckinSectionRef = useCIS4m(ref);

    const formData = useCIS4mData();
    const isRefferedDoctorAnderer = fieldValueIsNot(formData, PATH_REFFERED_DOCTOR, ['anderer']);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <p>{formatMessage(textMap.hausArztInfoText)}</p>
            <ZuweisenderArztField
                path={PATH_REFFERED_DOCTOR}
                label={textMap.zuweisenderArztRefferedDoctor}
                required={true}
            />
            <ArztBlock
                basePath={path}
                hidden={isRefferedDoctorAnderer}
                required={true}
                fieldsConfig={arztFieldsConfig}
                addressFieldsConfig={addressFieldsConfig}
            />
        </ECheckinSection>
    );
});

ZuweisenderArzt.displayName = 'ZuweisenderArzt';

export default ZuweisenderArzt;
